import { type FC } from 'react';

import { useCustomStyles } from './PriceBar.styles';

type Props = {
	isInvisible: boolean;
};

export const PlaceholderPriceBar: FC<Props> = ({ isInvisible }) => {
	const { classes, cx } = useCustomStyles({ rating: 0 });

	return (
		<li className={classes.columnContainer}>
			<label
				className={cx(classes.priceBarContainer, classes.placeHolderPriceBarContainer)}
				data-cy={isInvisible ? 'priceBar-placeholder' : 'priceBar-skeleton'}
			>
				<div
					className={cx(classes.priceBar, classes.placeholderPriceBar, {
						[classes.invisiblePriceBar]: isInvisible,
					})}
				>
					<div className={classes.priceContainer}>
						<div className={classes.priceLabel}>
							<span className={classes.textFrom} />
							<span className={classes.textPrice} data-cy="priceBar-textPrice" />
						</div>
					</div>
					<div>
						<div className={classes.tripDuration} />
					</div>
				</div>
				<div className={classes.priceBarSelect}>
					<p
						className={cx(classes.priceBarDate, classes.placeholderPriceBarDate, {
							[classes.invisiblePriceBar]: isInvisible,
						})}
						data-cy="priceBar-date"
					/>
				</div>
			</label>
		</li>
	);
};
